//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

// custom pages
import { styles } from "./styles";
import promotion from "apis/promotion/promotion";
import Context from "context/context";
//acress
import access from "config/access";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { useTranslation } from 'react-i18next';
// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function Create(props) {
  const { state, dispatch } = useContext(Context);

  const { createRange } = promotion();
  const history = useHistory();
  const classes = styles();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [states, setstates] = useState({
    minimumAmount: "",
    maximumAmount: "",
    multiplier: "",
    sequence: "",
    isActive: true,
    loading: false,
  });

  const {
    minimumAmount,
    maximumAmount,
    multiplier,
    sequence,
    isActive,
    loading,
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Promotion Management", "Range", "Create"],
    });
  }, []);

  const blockInvalidChar = (e) => {
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
    if (e.keyCode === 38 || e.keyCode === 40) {
      e.preventDefault();
    }
  }

  // create api func
  const handleCreate = async () => {
    try {
      if (parseInt(minimumAmount) > parseInt(maximumAmount)) {
        toast.error("Minimum amount should be lesser than maximum amount", {
          toastId: "required-fields-error-0",
        });
        setStates({ loading: false });
        return;
      }
      if (!minimumAmount || !maximumAmount || !multiplier) {
        toast.error("Please fill all the fields", {
          toastId: "required-fields-error",
        });
        setStates({ loading: false });
        return;
      }
      let values;
      values = {
        minimumAmount: parseInt(minimumAmount),
        maximumAmount: parseInt(maximumAmount),
        multiplier: parseInt(multiplier),
        isActive,
        promotionId: location?.state?.id,
      };
      if (sequence) {
        values = { ...values, sequence: parseInt(sequence) };
      }
      let res = await createRange(values);
      if (res) {
        toast.success("Created", { toastId: "range-created" });
        history.goBack();
      }
      setStates({ loading: false });
    } catch (e) {
      console.log({ e });
    }
  };


  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18, fontWeight: "bold" }}>{t('Create')}</span>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ padding: 10 }}>
        <Grid item xs={3}>
          <CssTextField
            label={t('Minimum Amount')}
            fullWidth
            type={"number"}
              onWheel={(e) => e.target.blur()}
            onKeyDown={blockInvalidChar}
            className={classes.cssTextField}
            required
            value={minimumAmount}
            onChange={(e) => {
              if (e.target.value >= 0) {
                setStates({ minimumAmount: e.target.value });
              }
            }}
          />
        </Grid>

        <Grid item xs={3}>
          <CssTextField
            label={t('Maximum Amount')}
            fullWidth
            type={"number"}
              onWheel={(e) => e.target.blur()}
            onKeyDown={blockInvalidChar}
            className={classes.cssTextField}
            required
            value={maximumAmount}
            onChange={(e) => {
              const value = e.target.value;
              if ((value === "" || (value > 0 && value.length <= 15))) {

                setStates({ maximumAmount: value});
              }
            }}
            error={maximumAmount.length === 15} // Show error when character limit is reached
            helperText={maximumAmount.length === 15 ? "MaximumAmount cannot exceed" : ""}
            inputProps={{ maxLength: 15 }}
          />
        </Grid>

       

        <Grid item xs={3}>
          <CssTextField
            label={t("Additional Multiplier")}
            fullWidth
            type={"number"}
              onWheel={(e) => e.target.blur()}
            onKeyDown={blockInvalidChar}
            className={classes.cssTextField}
            required
            value={multiplier}
            onChange={(e) => {
              const value = e.target.value;
              if (value === ""||value > 0 ) {

                setStates({ multiplier: value });
              }
            }}
          />
        </Grid>

        <Grid item xs={3}>
          <CssTextField
            label={t('Sequence')}
            fullWidth
            type={"number"}
              onWheel={(e) => e.target.blur()}
            onKeyDown={blockInvalidChar}
            className={classes.cssTextField}
            value={sequence}
            onChange={(e) => {
              if (e.target.value >= 0) {

                setStates({ sequence: e.target.value });
              }
            }}
          />
        </Grid>

        <Grid item xs={3}>
          <CssTextField
            id={"Is Active"}
            label={t("Is Active")}
            select
            fullWidth
            type={"text"}
            required
            value={isActive}
            onChange={(e) => {
              setStates({ isActive: e.target.value });
            }}
          >
            {[
              { label: "True", value: true },
              { label: "False", value: false },
            ].map((k, i) => (
              <MenuItem value={k.value} key={i}>
                {t(k.label)}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>
      </Grid>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          <Button
            className={classes.submitBtn}
            onClick={() => {
              if (state?.userInfo?.editAction) {
                setStates({ loading: true });
                handleCreate();
                return;
              }
              else {
                toast.error(state.userInfo?.editAccess)
                return;
              }
            }}
            disabled={loading}
          >
            {t('Submit')}
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
